import React, { useState } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Typography,
} from "@mui/material";
import { Notifications, Menu } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import astroguru from "../../assets/logo.png";
import NotificationDropdown from "../Notifications/NotificationDropdown";
import { mockNotifications } from "../Notifications/notificationData";

const Header = ({ onMenuClick }) => {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState(mockNotifications);

  const unreadCount = notifications.filter((n) => !n.read).length;

  const handleBellClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAllRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  // Map routes to page names
  const getPageName = () => {
    const path = location.pathname;
    const pageNames = {
      '/dashboard': 'Dashboard Overview',
      '/users': 'User Details',
      '/report': 'Reports',
      '/chat-ai': 'Chat AI',
      '/subscriptions': 'Subscriptions',
      '/compatibility-ai': 'Compatibility & Compare',
      '/prediction': 'Prediction',
      '/transactions': 'Earning & Transactions',
      '/notifications': 'Notifications',
    };
    return pageNames[path] || 'Dashboard';
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(26, 26, 26, 1)",
        color: "#FFFFFF",
        boxShadow: "none",
        height: "130px",
      }}
    >
      <Toolbar
        sx={{
          height: "130px",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "rgba(26, 26, 26, 1)",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

            <Box
              component="img"
              src={astroguru}
              alt="Astroguru Logo"
              sx={{
                height: { xs: "65px", md: "80px" },
                objectFit: "contain",
                marginLeft: { xs: "20px", md: "80px" },
              }}
            />

            {/* Page Name */}
            <Typography
              sx={{
                color: "#FFFFFF",
                fontSize: { md: "24px" },
                fontWeight: 600,
                marginLeft: { md: "100px" },
                display: { xs: "none", md: "block" },
              }}
            >
              {getPageName()}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton
            color="inherit"
            onClick={onMenuClick}
            sx={{
              display: { xs: "block", md: "none" },
              color: "#FFFFFF",
            }}
          >
            <Menu />
          </IconButton>
          <IconButton
            size="large"
            onClick={handleBellClick}
            sx={{
              backgroundColor: "#E1AD01",
              color: "#000000",
              width: 45,
              height: 45,
              "&:hover": {
                backgroundColor: "#E6B800",
              },
            }}
          >
            <Badge
              badgeContent={unreadCount}
              color="error"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "10px",
                  minWidth: "16px",
                  height: "16px",
                },
              }}
            >
              <Notifications sx={{ fontSize: 20 }} />
            </Badge>
          </IconButton>
        </Box>
      </Toolbar>

      <NotificationDropdown
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        notifications={notifications}
        onMarkAllRead={handleMarkAllRead}
      />
    </AppBar>
  );
};

export default Header;
